export const getSiteMaterialUrl = (siteMaterialId: number): string => {
  return `/quality/${String(siteMaterialId)}`;
};
